
(function() {
  function normalizeText(text) {
    return String(text || "")
      .toLowerCase()
      .replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      })
      .replace(/\s+/g, "");
  }

  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, function(match) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[match];
    });
  }

  function getTargetSection(link) {
    var href = link.getAttribute("href") || "";
    if (!href || href.charAt(0) !== "#") return null;
    return document.getElementById(href.slice(1));
  }

  function isComingSoon(text) {
    var t = normalizeText(text);
    return (
      t.indexOf("comingsoon") !== -1 ||
      t.indexOf("commingsoon") !== -1 ||
      t.indexOf("準備中") !== -1
    );
  }

  function shouldHideAccessTags(nav) {
    var root = nav.closest("[data-hide-access-tags='true']");
    return !!root;
  }

  function getLessonStatus(link, target) {
    var baseText = link.dataset.alOriginal || link.textContent || "";
    var targetText = target ? target.textContent : "";
    var combined = baseText + " " + targetText;

    if (isComingSoon(combined)) {
      return "";
    }

    if (target && target.querySelector(".aq-video")) {
      return "free";
    }

    if (target && target.querySelector(".join-hero")) {
      return "premium";
    }

    return "";
  }

  function getSearchText(link, target) {
    var linkText = link.dataset.alOriginal || link.textContent || "";
    var targetText = target ? target.textContent : "";
    var iframeTitle = "";

    if (target) {
      var iframe = target.querySelector("iframe");
      if (iframe) {
        iframeTitle = iframe.getAttribute("title") || "";
      }
    }

    return normalizeText(linkText + " " + targetText + " " + iframeTitle);
  }

  function setupTools(nav) {
    var tools = document.getElementById("al-search-tools");

    if (!tools) {
      var h3 = nav.querySelector("h3");

      tools = document.createElement("div");
      tools.id = "al-search-tools";
      tools.className = "al-tools";

      if (h3 && h3.nextSibling) {
        nav.insertBefore(tools, h3.nextSibling);
      } else {
        nav.insertBefore(tools, nav.firstChild);
      }
    }

    tools.innerHTML =
      '<label class="al-search-label" for="al-search-input">動画を検索</label>' +
      '<input id="al-search-input" class="al-search-input" type="search" placeholder="アナカリス、コケ、水漏れ、構図 など">' +
      '<div class="al-tool-buttons">' +
        '<button type="button" class="al-tool-button" id="al-close-all">すべて閉じる</button>' +
      '</div>';
  }

  function setupBadgesAndSearchData(nav) {
    var links = nav.querySelectorAll(".aq-list a");
    var hideTags = shouldHideAccessTags(nav);

    links.forEach(function(link) {
      var target = getTargetSection(link);

      if (!link.dataset.alOriginal) {
        link.dataset.alOriginal = link.textContent.trim();
      }

      var original = link.dataset.alOriginal;
      var status = getLessonStatus(link, target);
      var searchText = getSearchText(link, target);

      link.dataset.alSearch = searchText;

      var badgeHtml = "";

      if (!hideTags) {
        if (status === "free") {
          badgeHtml = '<span class="al-status-badge al-status-free">無料会員限定</span>';
        }

        if (status === "premium") {
          badgeHtml = '<span class="al-status-badge al-status-premium">プレミアムパス限定</span>';
        }
      }

      link.innerHTML =
        '<span class="al-badge-line">' + badgeHtml + '</span>' +
        '<span class="al-link-label">' + escapeHtml(original) + '</span>';
    });
  }

  function filterLessons(nav) {
    var input = document.getElementById("al-search-input");
    var noResult = document.getElementById("al-no-result");

    if (!input) return;

    var query = normalizeText(input.value);
    var links = nav.querySelectorAll(".aq-list a");
    var hitCount = 0;

    links.forEach(function(link) {
      var li = link.closest("li");
      var matched = !query || (link.dataset.alSearch || "").indexOf(query) !== -1;

      if (li) {
        li.classList.toggle("al-hidden", !matched);
        li.classList.toggle("al-hit", !!query && matched);
      }

      if (matched) hitCount++;
    });

    var courses = nav.querySelectorAll(".aq-course");

    courses.forEach(function(course) {
      var visibleItems = course.querySelectorAll(".aq-list li:not(.al-hidden)");
      var hasHit = visibleItems.length > 0;

      course.classList.toggle("al-hidden", !!query && !hasHit);

      if (query && hasHit) {
        course.open = true;
      }
    });

    if (!noResult) {
      noResult = document.createElement("div");
      noResult.id = "al-no-result";
      noResult.className = "al-no-result al-hidden";
      noResult.textContent = "該当する動画が見つかりませんでした。別のキーワードで検索してください。";
      nav.appendChild(noResult);
    }

    noResult.classList.toggle("al-hidden", !query || hitCount > 0);
  }

  function bindEvents(nav) {
    var input = document.getElementById("al-search-input");
    var closeAll = document.getElementById("al-close-all");

    if (input && !input.dataset.alBound) {
      input.dataset.alBound = "true";

      input.addEventListener("input", function() {
        filterLessons(nav);
      });
    }

    if (closeAll && !closeAll.dataset.alBound) {
      closeAll.dataset.alBound = "true";

      closeAll.addEventListener("click", function() {
        nav.querySelectorAll(".aq-course").forEach(function(course) {
          course.open = false;
        });
      });
    }
  }

  function initAlSearch() {
    var nav = document.querySelector("#aq-top .aq-side") || document.querySelector(".aq-side");
    if (!nav) return;

    setupTools(nav);
    setupBadgesAndSearchData(nav);
    bindEvents(nav);
    filterLessons(nav);
  }

  /*
   * Vimeo共通設定
   *
   * 既存の動画ID・src・会員制御を変更しない。
   * 全画面表示と再生の許可を明示する。
   * 既存の遅延読み込みを維持する。
   * 処理を繰り返しても設定を重複させない。
   */
  function initAlVimeo() {
    var frames = document.querySelectorAll(
      ".aq-page iframe[src*='player.vimeo.com/video/']"
    );

    frames.forEach(function(frame) {
      if (frame.dataset.alVimeoConfigured === "true") {
        return;
      }

      var currentAllow = frame.getAttribute("allow") || "";
      var permissions = currentAllow
        .split(";")
        .map(function(item) {
          return item.trim();
        })
        .filter(function(item) {
          return item.length > 0;
        });

      [
        "autoplay",
        "fullscreen",
        "picture-in-picture"
      ].forEach(function(permission) {
        var exists = permissions.some(function(item) {
          return item.split(/\s+/)[0] === permission;
        });

        if (!exists) {
          permissions.push(permission);
        }
      });

      frame.setAttribute("allow", permissions.join("; "));

      if (!frame.hasAttribute("allowfullscreen")) {
        frame.setAttribute("allowfullscreen", "");
      }

      if (!frame.hasAttribute("loading")) {
        frame.setAttribute("loading", "lazy");
      }

      frame.dataset.alVimeoConfigured = "true";
    });
  }

  function initAl() {
    initAlVimeo();
    initAlSearch();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAl);
  } else {
    initAl();
  }

  setTimeout(initAl, 100);

  document.addEventListener("shopify:section:load", function() {
    initAl();
  });
})();
